import { render, staticRenderFns } from "./table-row.judging.vue?vue&type=template&id=87fc284a&scoped=true&"
import script from "./table-row.judging.vue?vue&type=script&lang=js&"
export * from "./table-row.judging.vue?vue&type=script&lang=js&"
import style0 from "./table-row.judging.vue?vue&type=style&index=0&id=87fc284a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fc284a",
  null
  
)

export default component.exports